import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

/* eslint-disable react/jsx-props-no-spreading */

const StyledModal = ({ children, ...props }) => (
  <Modal {...props}>
    <div className="p-3">{children}</div>
  </Modal>
);

StyledModal.Header = ({ children, hasTitle = true, ...props }) => {
  const className = hasTitle ? 'pb-3 px-0 pt-1' : 'border-0 pb-0 px-0 pt-1';

  return (
    <Modal.Header className={className} closeButton {...props}>
      {children}
    </Modal.Header>
  );
};

StyledModal.Title = Modal.Title;

StyledModal.Body = ({ children, ...props }) => (
  <Modal.Body
    className="content px-0 d-flex justify-content-center flex-column"
    {...props}
  >
    {children}
  </Modal.Body>
);

StyledModal.Footer = ({ children, ...props }) => (
  <Modal.Footer className="p-0 border-0" {...props}>
    {children}
  </Modal.Footer>
);

const basicShape = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  // eslint-disable-next-line react/forbid-prop-types
  props: PropTypes.object,
};

StyledModal.propTypes = basicShape;
StyledModal.Header.propTypes = {
  hasTitle: PropTypes.bool,
  ...basicShape,
};
StyledModal.Body.propTypes = basicShape;
StyledModal.Footer.propTypes = basicShape;

export default StyledModal;
